/**************************************************
 * Nombre:       Formulario_Pedido_Envio
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {
    AccountBalanceOutlined,
    BalanceOutlined,
    Flag,
    PointOfSaleOutlined,
    SignpostOutlined
} from "@mui/icons-material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {useEffect, useState} from "react";
import IngresoDinero from "../../Modulo_formularios/Componentes/IngresoDinero";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {ESTADOSPAGO} from "../../Constantes";
import {obtenerDatosTransaccion} from "../../Modulo_Wompi/Funciones/obtenerDatosTransaccion";
import {formatoMoneda} from "../../Modulo_Wompi/Utilidades/formatoMoneda";


const Formulario_Pedido_Pago = ({...props}) => {
    const [idTrans, setIdTrans] = useState('')
    const [cargando, setCargando] = useState(false)
    const [datos, setDatos] = useState({})
    const verificar = async () => {

        setCargando(true)
        let dox = await obtenerDatosTransaccion(idTrans)
        console.log(dox)
        setDatos(dox)
        setCargando(false)

    }

    useEffect(() => {

        let num = props.props.getValues('idTransaccion')
        setIdTrans(num)

    }, [props.props.watch('idTransaccion')]);
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={6}>
                    <IngresoTexto Icono={Flag} nombre={'Num Pedido'} dato={'consecutivo'} editable={false} {...props} />
                </Grid>

                <Grid container size={6}>
                    <IngresoSelect Icono={SignpostOutlined} nombre={'Estado'} dato={'estadoPago'} {...props}
                                   opciones={ESTADOSPAGO.map((it) => it.nombre)}/>
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={AccountBalanceOutlined} nombre={'Id Transaccion'}
                                  dato={'idTransaccion'} {...props}
                                  editable={false}/>
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={SignpostOutlined} nombre={'Metodo'} dato={'metodo'} {...props}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoDinero Icono={PointOfSaleOutlined} nombre={'Valor Pagado'} dato={'valorPagado'}
                                   {...props} />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={PointOfSaleOutlined} nombre={'Mensaje Pago'} dato={'mensaje'}
                                   {...props} />
                </Grid>

                <Grid container size={6}>
                    {datos.status &&
                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            spacing={0}>

                            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                                <Typography>{`Estado: ${datos.status}`}</Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: -0.5}}>
                                <Typography sx={{fontSize: 14}} >{`Valor Pagado: ${formatoMoneda(datos.amount_in_cents / 100)}`}</Typography>
                            </Grid>


                        </Grid>
                    }
                </Grid>

                <Grid container size={6} justifyContent={'flex-end'}>
                    <Button
                        onClick={() => verificar(idTrans)}
                        loading={cargando}
                        variant={'outlined'} startIcon={<BalanceOutlined/>}>Verificar</Button>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Pedido_Pago